/*
  Custom Collection Tabs (sections/Custom-collection-tabs.liquid): switching tabs.
  SEO п.32 (INP on mobile): only the first tab of a block comes with its cards in the page HTML. A tab marked
  data-tab-lazy gets its cards on the first open: the same section is requested with the Section Rendering API on the
  same page address, ?section_id=<section id>&page=<9000 + tab number> (the section renders only that tab's cards).
  The request starts already on pointerdown / hover / focus of the tab button, so the click itself only switches the panels.
  The script is included by every tab section on the page, so it sets itself up once.

  Upsell Kit labels ("Nuevo", "Favorito", "-25%"): the app embed labels the product cards once, when the page starts,
  from its settings in window.CKTools.labels_stickers and window.CKSettings. Cards of a lazy tab arrive later, so the same
  labels are added to them here with the app's markup (see appLabels). If the app makes its first pass only after a tab was
  loaded, it labels these cards again: it does not check for its own labels. A second copy of a label in a card of a loaded
  tab is therefore removed as soon as it is added (see guardLabels).

  Clay B2B prices (the full price crossed out and the rule price next to it, e.g. 5.25 -> 4.25): the app embed rewrites the
  price of every card whose product has a pricing rule for the visitor's customer group, guests included (group ALL).
  It looks for such cards during 10 s after the page starts and again during 10 s after every change of the address through
  history.pushState / replaceState / popstate. The cards of a tab loaded later are therefore shown to the app with
  history.replaceState() to the same address and state (see clayPrices): nothing changes for the browser, and the other
  scripts that watch the history (Google tag, Meta pixel) compare the address and send nothing.
*/
(function () {
  if (window.xCollectionTabs) return;

  var LAZY_PAGE_OFFSET = 9000;
  var requests = {};

  // a pass of Clay B2B lasts 10 s and picks up the cards added meanwhile by itself, so a new one is started only after 8 s
  var CLAY_PASS_MS = 8000;
  var clayPassAt = 0;

  // Upsell Kit: the card selector the app uses when CKSettings.productCardSelector is empty
  var APP_CARD_SELECTORS =
    ".grid.product-grid li.grid__item,Product-recommendations ul li.grid__item,.collection__main .product-list .product-card,.collection-grid__wrapper .grid .grid__item,.collection__results .product-list .product-card,.collection-listing .product-list .product-block,.grid .grid-item.product-item,.productgrid--items .productgrid--item,.grid .card.card--product,.collection .product-grid .grid__item,.collection__products product-grid-item,.grid .grid__item.grid-product,.product-list.product-list--collection .product-item,.collection__products .product-item,.product-list .product-list__inner .product-item,.product-grid .grid-item.grid-product,#product-grid .product-card,#CollectionProductGrid .product-item,.grid .product-grid-item.grid__item,.products.collection .product-card,[data-collection-products] [data-product-grid],.collection-main-body .grid__item,.product-list-container .product-list .product-block,.cc-filters-results .grid-flex .product-block,.collection-products .collection__cards .product-card,.collection.grid .product-item__wrapper,product-card";

  // one label of the app, built the way the app builds it: div.ewck-ls-c.ewck-ls-c-<label number> > div.ewck-ls-w > badge
  function appLabel(label, index, settings) {
    var box = document.createElement('div');
    box.className = 'ewck-ls-c ewck-ls-c-' + index;
    box.style.cssText = 'position:unset';
    if (settings.css) {
      var css = document.createElement('style');
      css.innerHTML = settings.css;
      box.appendChild(css);
    }

    var place = 'position:absolute;top:0;z-index:1;';
    if (label.position === 'Left') place += 'left:0;';
    else if (label.position === 'Middle') place += 'left:50%;transform:translateX(-50%);';
    else place += 'right:0;';

    var picture = function (src, size, marginY, marginX) {
      return (
        "<div style='width:" + size + 'px;height:' + size + 'px;margin-block:' + marginY + 'px;margin-inline:' + marginX +
        "px;'><img src='" + src + "' alt='sticker' style='width:100%;height:auto;object-fit:cover' /></div>"
      );
    };

    var html;
    if (label.badgeType === 'Text') {
      if (typeof label.textEffectCode !== 'string') return null;
      var text = label.badgeText;
      var translation = label.translations && window.Shopify ? label.translations[window.Shopify.locale] : null;
      if (translation) text = translation.badgeText;
      var props = label.cssProperties || {};
      html = label.textEffectCode
        .replaceAll('{{label}}', text)
        .replaceAll(
          '{{background}}',
          props.badgeBackgroundColor + ';' +
            (label.textMarginY ? 'margin-block:' + label.textMarginY + 'px;' : '') +
            (label.textMarginX ? 'margin-inline:' + label.textMarginX + 'px' : '')
        )
        .replaceAll('<h2', '<div')
        .replaceAll('</h2>', '</div>')
        .replaceAll('{{fontFamily}}', props.fontFamily)
        .replaceAll('{{badgePaddingY}}', props.badgePaddingY + 'px')
        .replaceAll('{{badgePaddingX}}', props.badgePaddingX + 'px')
        .replaceAll('{{textColor}}', props.textColor)
        .replaceAll('{{fontSize}}', props.fontSize + 'px')
        .replaceAll('{{borderRadius}}', props.borderRadius + 'px')
        .replaceAll('{{fontUrl}}', props.fontUrl);
    } else if (label.badgeType === 'Sticker') {
      var sticker = String(label.sticker);
      if (sticker.indexOf('cloudinary.com') !== -1) {
        sticker = 'https://d2nt3atlyf8bm0.cloudfront.net/shopify/apps/upsell-kit/labels-stickers/' + sticker.slice(sticker.lastIndexOf('/') + 1);
      }
      html = picture(sticker, label.stickerSize, label.stickerMarginY, label.stickerMarginX);
    } else {
      html = picture(label.imageUrl, label.imageSize, label.imageMarginY, label.imageMarginX);
    }

    var badge = document.createElement('div');
    badge.className = 'ewck-ls-w';
    badge.style.cssText = place;
    badge.innerHTML = html;
    box.appendChild(badge);
    return box;
  }

  // labels for the cards of a loaded tab: the same rules as the app (active label, all products or the card's product handle)
  function appLabels(panel) {
    var tools = window.CKTools;
    var labels = tools && Array.isArray(tools.labels_stickers) ? tools.labels_stickers : null;
    if (!labels || !String.prototype.replaceAll) return;
    var settings = window.CKSettings || {};
    var cards = panel.querySelectorAll(settings.productCardSelector || APP_CARD_SELECTORS);

    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var link = card.tagName === 'A' ? card : card.querySelector("a[href*='/products/']");
      if (!link || link.href.indexOf('/products/') === -1) continue;
      var handle = link.href.split('/products/')[1].split('?')[0];

      for (var i = 0; i < labels.length; i++) {
        var label = labels[i];
        if (!label || label.status === 'Inactive') continue;
        if (label.resourceType !== 'all' && !(Array.isArray(label.productHandles) && label.productHandles.indexOf(handle) !== -1)) continue;
        if (card.querySelector('.ewck-ls-c-' + i)) continue;
        if (card.style.position === '' || card.style.position === 'unset') card.style.position = 'relative';
        var target = settings.labelsStickersProductCardTarget ? card.querySelector(settings.labelsStickersProductCardTarget) : card;
        var element = target ? appLabel(label, i, settings) : null;
        if (element) target.appendChild(element);
      }
    }
  }

  // keeps one copy of each app label in a card of a loaded tab
  function guardLabels(panel) {
    if (panel.xLabelsGuard || !window.MutationObserver) return;
    panel.xLabelsGuard = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, function (node) {
          if (node.nodeType !== 1 || !node.parentElement || !node.classList.contains('ewck-ls-c')) return;
          var number = Array.prototype.filter.call(node.classList, function (name) {
            return name.indexOf('ewck-ls-c-') === 0;
          })[0];
          if (!number) return;
          var siblings = node.parentElement.children;
          for (var i = 0; i < siblings.length; i++) {
            if (siblings[i] !== node && siblings[i].classList.contains(number)) {
              node.remove();
              return;
            }
          }
        });
      });
    });
    panel.xLabelsGuard.observe(panel, { childList: true, subtree: true });
  }

  // Clay B2B: a new pass over the product cards of the page, so the cards of a loaded tab get their prices too
  function clayPrices() {
    if (!window.clayStorefrontConfig || window.useCustomCode) return;
    var now = Date.now();
    if (clayPassAt && now - clayPassAt < CLAY_PASS_MS) return;
    clayPassAt = now;
    try {
      window.history.replaceState(window.history.state, '', window.location.href);
    } catch (error) {
      // the cards keep the prices the theme rendered
    }
  }

  // after the browser has shown the cards, outside the tap that opened the tab
  function afterPaint(callback) {
    window.requestAnimationFrame(function () {
      setTimeout(callback, 0);
    });
  }

  function panelOf(tab) {
    return document.getElementById(tab.getAttribute('data-tab'));
  }

  function tabFrom(event) {
    var target = event.target;
    var tab = target && target.closest ? target.closest('.tab-link-custom') : null;
    return tab && tab.closest('[data-collection-tabs]') ? tab : null;
  }

  function sectionUrl(sectionId, tabIndex) {
    var params = new URLSearchParams();
    var view = new URLSearchParams(window.location.search).get('view');
    if (view) params.set('view', view);
    params.set('section_id', sectionId);
    params.set('page', String(LAZY_PAGE_OFFSET + tabIndex));
    return window.location.pathname + '?' + params.toString();
  }

  function request(panel) {
    if (!panel || !panel.hasAttribute('data-tab-lazy')) return null;
    if (requests[panel.id]) return requests[panel.id];
    var container = panel.closest('[data-collection-tabs]');
    var sectionId = container && container.getAttribute('data-section-id');
    var tabIndex = parseInt(panel.getAttribute('data-tab-index'), 10);
    if (!sectionId || !tabIndex) return null;

    var headers = {};
    // without the store's session cookie Shopify would redirect the request to the browser language (see pickup-availability)
    if (document.documentElement.lang) headers['Accept-Language'] = document.documentElement.lang;

    requests[panel.id] = fetch(sectionUrl(sectionId, tabIndex), { headers: headers })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.getElementById(panel.id);
        var cards = source ? source.querySelector('slider-component') : null;
        if (!cards) throw new Error('no cards for ' + panel.id);
        return { cards: cards, styles: Array.prototype.slice.call(doc.querySelectorAll('link[rel="stylesheet"]')) };
      })
      .catch(function (error) {
        delete requests[panel.id];
        throw error;
      });
    return requests[panel.id];
  }

  function hasStylesheet(href) {
    var links = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href') === href) return true;
    }
    return false;
  }

  function fill(panel) {
    var pending = request(panel);
    if (!pending) return;
    var placeholder = panel.querySelector('[data-tab-placeholder]');
    var spinner = placeholder ? placeholder.querySelector('.loading__spinner') : null;
    if (spinner) spinner.classList.remove('hidden');
    panel.setAttribute('aria-busy', 'true');

    pending
      .then(function (result) {
        if (!panel.hasAttribute('data-tab-lazy')) return;
        // the first card brings the card styles; add only those the page does not have yet
        result.styles.forEach(function (link) {
          var href = link.getAttribute('href');
          if (href && !hasStylesheet(href)) document.head.appendChild(link);
        });
        if (placeholder) {
          placeholder.replaceWith(result.cards);
        } else {
          panel.insertBefore(result.cards, panel.firstChild);
        }
        panel.removeAttribute('data-tab-lazy');
        panel.removeAttribute('aria-busy');
        try {
          appLabels(panel);
          guardLabels(panel);
        } catch (error) {
          // the labels are decoration: the cards stay usable without them
        }
        afterPaint(clayPrices);
      })
      .catch(function () {
        // the tab stays empty with its "Ver todo" link; the next click tries again
        if (spinner) spinner.classList.add('hidden');
        panel.removeAttribute('aria-busy');
      });
  }

  function activate(tab) {
    var container = tab.closest('.collection-tabs-container');
    if (!container) return;
    var targetId = tab.getAttribute('data-tab');
    var panels = container.querySelectorAll('.tab-panel-custom');
    var target = document.getElementById(targetId);

    // the empty tab keeps the height of the tab shown now, so the page does not jump while the cards load
    if (target && target.hasAttribute('data-tab-lazy')) {
      var placeholder = target.querySelector('[data-tab-placeholder]');
      for (var i = 0; i < panels.length; i++) {
        if (panels[i] !== target && panels[i].style.display !== 'none') {
          var shown = panels[i].querySelector('slider-component');
          if (placeholder && shown) placeholder.style.minHeight = shown.offsetHeight + 'px';
          break;
        }
      }
    }

    container.querySelectorAll('.tab-link-custom').forEach(function (btn) {
      btn.classList.add('button--secondary');
      btn.setAttribute('aria-selected', 'false');
    });
    tab.classList.remove('button--secondary');
    tab.setAttribute('aria-selected', 'true');
    panels.forEach(function (panel) {
      panel.style.display = panel.id === targetId ? 'block' : 'none';
    });

    if (target && target.hasAttribute('data-tab-lazy')) fill(target);
  }

  document.addEventListener('click', function (event) {
    var tab = tabFrom(event);
    if (tab) activate(tab);
  });

  ['pointerdown', 'mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var tab = tabFrom(event);
        if (!tab) return;
        var pending = request(panelOf(tab));
        if (pending) pending.catch(function () {});
      },
      { passive: true }
    );
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.closest ? event.target.closest('.tab-link-custom') : null;
    if (tab) activate(tab);
  });

  window.xCollectionTabs = { activate: activate };
})();
